export async function Post(token: string | null, data: any) {
    const axios = require('axios');
    const url =  process.env.REACT_APP_HOST + 'api/Session';
    const headers = {
        'accept': 'application/json',
        'authorization': `Bearer ${token}`,
        'content-type': 'application/json',
    };
    const payload = {
        value: JSON.stringify(data)
    };

    try {
        const response = await axios.post(url, payload, { headers });
        return response.data;
    } catch (error) {
        console.error('Error making POST request:', error);
    }
}